import { useState } from "react";
import ButtonComponent from "../../../components/button/button.component";
import RestApi from "../../../../data/settings/RestApi";

interface Props {
    agentId: string;
    assistantId: string;
    vectorStoreId?: string;
    onUploaded: () => void;
}

const UploadFilesToAgentComponent = ({
    agentId,
    assistantId,
    vectorStoreId,
    onUploaded
}: Props) => {
    const [files, setFiles] = useState<FileList | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const validateFiles = (fileList: FileList): string | null => {
        const allowedExtensions = [".txt", ".pdf", ".docx", ".pptx", ".xlsx", ".csv", ".json", ".md"];
        const maxFiles = 10;
        const maxSizeMB = 100;

        if (fileList.length > maxFiles) return `Max 10 files allowed. Received: ${fileList.length}`;

        const totalSize = Array.from(fileList).reduce((acc, file) => acc + file.size, 0);
        if (totalSize > maxSizeMB * 1024 * 1024)
            return `Total file size exceeds 100 MB. Received: ${(totalSize / 1024 / 1024).toFixed(2)} MB`;

        for (let file of fileList) {
            const ext = "." + file.name.split(".").pop();
            if (!allowedExtensions.includes(ext)) {
                return `File format ${ext} not supported. Allowed formats: ${allowedExtensions.join(", ")}`;
            }
        }

        return null;
    };

    const _handleSubmit = async () => {
        if (!files) return setError("Please select files");

        const validationError = validateFiles(files);
        if (validationError) return setError(validationError);

        const formData = new FormData();
        formData.append("assistant_id", assistantId);
        if (vectorStoreId) formData.append("vector_store_id", vectorStoreId);
        Array.from(files).forEach((file) => formData.append("files", file));

        setLoading(true);
        try {
            const api = new RestApi();
            await api.post(`/agent/${agentId}/files`, formData);            onUploaded();
            setFiles(null);
            setError(null);
        } catch (err) {
            setError("Error uploading files");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <label>Upload Additional Files:</label>
            <input
                type="file"
                multiple
                onChange={(e) => setFiles(e.target.files)}
                disabled={loading}
                className="form-control mb-2"
            />
            {error && <div className="text-danger">{error}</div>}
            <ButtonComponent text="Upload Files" onClick={_handleSubmit} isLoading={loading} />
        </div>
    );
};

export default UploadFilesToAgentComponent;
